import { alias, list, object, primitive, serializable } from "serializr";
import { CoProducts } from "./coProducts.model";

export class CommodityOverview {

    @serializable(alias('raw_materials_emission', primitive()))
    rawMaterialsEmission?: number;

    @serializable(alias('transportation_emission', primitive()))
    transportationEmission?: number;

    @serializable(alias('scope_1_and_2_emission', primitive()))
    scope1And2Emission?: number;

    @serializable(alias('field_emission', primitive()))
    fieldEmission?: number;

    @serializable(alias('distribution_emission', primitive()))
    distributionEmission?: number;

    @serializable(alias('harvest_year', primitive()))
    harvestYear?: number;

    @serializable(alias('farm_name', primitive()))
    farmName?: string;

    @serializable(alias('crop_name', primitive()))
    cropName?: string;

    @serializable(alias('dry_weight', primitive()))
    dryWeight?: number;

    @serializable
    area?: number;

    @serializable(alias('area_unit', primitive()))
    areaUnit?: string;

    @serializable
    name?: string;

    @serializable(alias('image_url', primitive()))
    imageUrl?: string;

    @serializable
    status?: string;

    @serializable(alias('co_products', list(object(CoProducts))))
    CoProducts?: CoProducts[];

}